/** @file The paint tool's Animate-mode stale-bind notice: once per mesh until its bind is fresh again. */
import type { Id } from '@pose2d/format/types';
import type { ToolContext } from '../../panels/viewport/viewportTypes';

/** Meshes whose notice was shown (one viewport per page); a press on a fresh bind forgets the mesh. */
export const staleNotice = {
  shown: new Set<Id>(),
  /** Notifies `tools.paintWeights.staleBind` the first time a stroke starts on `attachment` while `stale`. */
  stroke(ctx: ToolContext, attachment: Id, stale: boolean): void {
    if (!stale) {
      staleNotice.shown.delete(attachment);
      return;
    }
    if (staleNotice.shown.has(attachment)) return;
    staleNotice.shown.add(attachment);
    ctx.notify({ kind: 'info', key: 'tools.paintWeights.staleBind' });
  },
};
